module.exports = __webpack_public_path__ + "static/media/icon-helpline.cbef04f0.svg";